import { gql } from '@apollo/client'

/**
 * Query to get the members of the workspace
 */
export const GET_WORKSPACE_MEMBERS = gql`
  query WorkspaceMembers($input: WorkspaceMembersDTO) {
    workspaceMembers(input: $input) {
      userID
      workspaceID
      accessType
      status
      user {
        id
        name
        photo
        email
        phone
        countryCode
      }
    }
  }
`

export const DOES_USER_EXIST = gql`
  query DoesUserExist($emailOrPhone: String!) {
    userExists(input: { emailOrPhone: $emailOrPhone }) {
      id
      countryCode
      phone
      email
      name
      photo
      memberships {
        workspaceID
        role
        workspace {
          displayName
          logo
        }
      }
    }
  }
`
